module.exports = __webpack_public_path__ + "img/buzz-sentiment-disabled.e5317edf.svg";